import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';


const FeatureCard = ({ title, description, delay }) => {

    const navigate = useNavigate();

    const renderFeature = (title) => {
        console.log("title==>", title)
        navigate(`/feature/${title}`);
    }

    return(
        <Grid item xs={12} md={4} data-aos="fade-up" data-aos-delay={delay}>
            <Box className="feature-card">
                <Typography variant="h5" className='service-title'  onClick={()=>{renderFeature(title)}} >{title}</Typography>
                <Typography variant="body1" className="feature-description">
                    {description}
                </Typography>
            </Box>
        </Grid>
    );
};

const Features = () => {
  return (
    <Box id="features" className="features">
      <Container>
        <Typography variant="h4" className="section-title" data-aos="fade-up">
          Why Choose Us?
        </Typography>
        <Grid container spacing={4} sx={{ marginTop: '30px' }}>
          <FeatureCard title="Innovation" description="We are at the cutting edge of technology." delay="200" />
          <FeatureCard title="Experience" description="Years of expertise in the industry." delay="300" />
          <FeatureCard title="Quality" description="Delivering quality solutions every time." delay="400" />
        </Grid>
      </Container>
    </Box>
  );
};

export default Features;
